import _defineProperty from "/workdir/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable no-magic-numbers */
import moment from 'moment';
import { TimeRangeNames } from '../../types/whats-on';
const noFilterString = '';
export const getTimeRangeSlug = name => (name || '').split(' ').join('-').toLowerCase();
var DaysOfTheWeek;

(function (DaysOfTheWeek) {
  DaysOfTheWeek[DaysOfTheWeek["Sunday"] = 0] = "Sunday";
  DaysOfTheWeek[DaysOfTheWeek["Monday"] = 1] = "Monday";
  DaysOfTheWeek[DaysOfTheWeek["Tuesday"] = 2] = "Tuesday";
  DaysOfTheWeek[DaysOfTheWeek["Wednesday"] = 3] = "Wednesday";
  DaysOfTheWeek[DaysOfTheWeek["Thursday"] = 4] = "Thursday";
  DaysOfTheWeek[DaysOfTheWeek["Friday"] = 5] = "Friday";
  DaysOfTheWeek[DaysOfTheWeek["Saturday"] = 6] = "Saturday";
})(DaysOfTheWeek || (DaysOfTheWeek = {}));

const toDay = date => parseInt(date.format('d'));

class InvalidTimeRange {
  constructor() {
    _defineProperty(this, "startsAt", moment(0));

    _defineProperty(this, "endsAt", moment(0));

    _defineProperty(this, "name", TimeRangeNames.Never);
  }

  slug() {
    return '';
  }

  isValid() {
    return false;
  }

  isInRange() {
    return false;
  }

}

class ValidTimeRange {
  constructor({
    startsAt,
    endsAt,
    name = TimeRangeNames.Never
  }) {
    _defineProperty(this, "startsAt", void 0);

    _defineProperty(this, "endsAt", void 0);

    _defineProperty(this, "name", void 0);

    this.startsAt = startsAt;
    this.endsAt = endsAt;
    this.name = name;
  }

  slug() {
    return getTimeRangeSlug(this.name);
  }

  isValid() {
    return true;
  }

  isInRange(date) {
    return date.valueOf() >= this.startsAt.valueOf() && date.valueOf() <= this.endsAt.valueOf();
  }

} // the null option is here for non-TS consumers


const validOptions = options => Boolean(options && Boolean(options.range) && Boolean(options.baseTime));

const startOfDay = date => moment(date).startOf('day');

const endOfDay = date => moment(date).endOf('day'); // we need to do moment again to create a new object rather than reference the same one


const todaysTimes = baseTime => ({
  startsAt: moment(baseTime),
  endsAt: endOfDay(baseTime)
});

const todaysTimesFromStart = baseTime => ({
  startsAt: startOfDay(baseTime),
  endsAt: endOfDay(baseTime)
});

const addDays = ({
  extraStart,
  extraEnd
}, timeRange) => ({
  startsAt: timeRange.startsAt.add(extraStart, 'days'),
  endsAt: timeRange.endsAt.add(extraEnd, 'days')
});

const tomorrowsTimes = baseDate => addDays({
  extraStart: 1,
  extraEnd: 1
}, todaysTimesFromStart(baseDate));

const daysUntilFriday = date => 5 - toDay(date);

const thisWeeksTimes = (baseDate, selectedFilter) => addDays({
  extraStart: selectedFilter === 'this-week' ? 0 : 2,
  extraEnd: daysUntilFriday(baseDate)
}, todaysTimes(baseDate));

const daysUntilStartOfWeekend = (date, selectedFilter) => {
  if (selectedFilter === 'this-weekend') {
    if (toDay(date) === DaysOfTheWeek.Sunday) {
      return -1;
    }

    return 6 - toDay(date);
  } else {
    return 6 - toDay(date) + (toDay(date) === DaysOfTheWeek.Friday ? 1 : 0) + (toDay(date) === DaysOfTheWeek.Saturday ? 7 : 0) + (toDay(date) === DaysOfTheWeek.Sunday ? 6 : 0);
  }
};

const daysUntilSunday = date => {
  if (toDay(date) === DaysOfTheWeek.Sunday) {
    return 0;
  } else {
    return 7 - toDay(date);
  }
};

const thisWeekendsTimes = (baseDate, selectedFilter) => addDays({
  extraStart: daysUntilStartOfWeekend(baseDate, selectedFilter),
  extraEnd: daysUntilSunday(baseDate)
}, todaysTimesFromStart(baseDate));

const daysUntilNextMonday = date => 8 - toDay(date);

const daysUntilNextSunday = date => daysUntilNextMonday(date) + 6;

const nextWeeksTimes = baseDate => addDays({
  extraStart: daysUntilNextMonday(baseDate),
  extraEnd: daysUntilNextSunday(baseDate)
}, todaysTimesFromStart(baseDate));

const daysUntilMondayAfterNextWeek = date => 15 - toDay(date);

const daysUntilOneMonthAfterNextWeek = date => daysUntilMondayAfterNextWeek(date) + 29;

const upcomingTimes = baseDate => addDays({
  extraStart: daysUntilMondayAfterNextWeek(baseDate),
  extraEnd: daysUntilOneMonthAfterNextWeek(baseDate)
}, todaysTimesFromStart(baseDate));

const invalidTimes = () => ({
  startsAt: moment(1),
  endsAt: moment(0),
  name: TimeRangeNames.Never,
  slug: ''
});

const timesForRange = (range, baseTime, selectedFilter) => {
  if (range === TimeRangeNames.Today) {
    return _objectSpread(_objectSpread({}, todaysTimes(baseTime)), {}, {
      name: range,
      slug: getTimeRangeSlug(range)
    });
  } else if (range === TimeRangeNames.Tomorrow) {
    if (toDay(baseTime) === DaysOfTheWeek.Sunday) {
      return invalidTimes();
    } else {
      return _objectSpread(_objectSpread({}, tomorrowsTimes(baseTime)), {}, {
        name: range,
        slug: getTimeRangeSlug(range)
      });
    }
  } else if (range === TimeRangeNames.ThisWeek) {
    if (toDay(baseTime) === DaysOfTheWeek.Sunday) {
      return invalidTimes();
    } else {
      return _objectSpread(_objectSpread({}, thisWeeksTimes(baseTime, selectedFilter)), {}, {
        name: range,
        slug: getTimeRangeSlug(range)
      });
    }
  } else if (range === TimeRangeNames.ThisWeekend) {
    return _objectSpread(_objectSpread({}, thisWeekendsTimes(baseTime, selectedFilter)), {}, {
      name: range,
      slug: getTimeRangeSlug(range)
    });
  } else if (range === TimeRangeNames.NextWeek) {
    return _objectSpread(_objectSpread({}, nextWeeksTimes(baseTime)), {}, {
      name: range,
      slug: getTimeRangeSlug(range)
    });
  } else if (range === TimeRangeNames.Upcoming) {
    return _objectSpread(_objectSpread({}, upcomingTimes(baseTime)), {}, {
      name: range,
      slug: getTimeRangeSlug(range)
    });
  } else {
    return invalidTimes();
  }
};

export const timeRange = options => {
  if (validOptions(options)) {
    const times = timesForRange(options.range, options.baseTime, options.selectedFilter);

    if (times.startsAt.valueOf() < times.endsAt.valueOf()) {
      return new ValidTimeRange(_objectSpread({}, times));
    } else {
      return new InvalidTimeRange();
    }
  } else {
    return new InvalidTimeRange();
  }
};
export const rangesForDate = (date, selectedFilter = noFilterString) => [timeRange({
  range: TimeRangeNames.Today,
  baseTime: date,
  selectedFilter
}), timeRange({
  range: TimeRangeNames.Tomorrow,
  baseTime: date,
  selectedFilter
}), timeRange({
  range: TimeRangeNames.ThisWeek,
  baseTime: date,
  selectedFilter
}), timeRange({
  range: TimeRangeNames.ThisWeekend,
  baseTime: date,
  selectedFilter
}), timeRange({
  range: TimeRangeNames.NextWeek,
  baseTime: date,
  selectedFilter
}), timeRange({
  range: TimeRangeNames.Upcoming,
  baseTime: date,
  selectedFilter
})].filter(range => range.isValid());

const stripOffset = inputTime => {
  let [datePart, timePart] = inputTime.split('T'); // eslint-disable-line prefer-const

  if (timePart) {
    timePart = timePart.replace(/Z$/, '');
  } // Handle time string with time offset like 2019-01-01T03:00+01:00


  return timePart ? "".concat(datePart, "T").concat(timePart.replace(/[+-](?=[^[+-]*$)+.*$/, '')) : inputTime;
};

export const timezonelessTime = inputTime => {
  const t = stripOffset(inputTime);
  return "".concat(t, "Z");
};
export const timezonelessDate = inputTime => moment(timezonelessTime(inputTime)).utc();
export const isInTimeRange = inputTimeRange => occurrence => inputTimeRange.isInRange(occurrence.endAt);